<template>
    <b-modal size="md" id="linkToAppModal" 
            header-bg-variant="info"
            header-text-variant="white"
            body-bg-variant="light" 
            footer-bg-variant="light"
            :title="$t('link.to.app.title')"
            title-class="lead"
            >
                
            <p class="text-center text-muted smart-size mt-2 mb-4">{{$t('link.to.app.subtitle')}}</p>
            <div class="text-center">
                {{urlToApp}}
            </div>
            <div class="text-center m-4">
                <qrcode-vue id="qrbarcode" class="d-inline-block"  :value="urlToApp" />
            </div>
                   
        <template #modal-footer="{ hide }">
            <b-button variant="secondary" block @click="hide('forget')">{{$t('close')}}</b-button>
      </template>
                    
    </b-modal>
    </template>
    
    <script>
    import { mapGetters, mapState } from 'vuex'
    import QrcodeVue from 'qrcode.vue'
    
    export default {
        data () {
            return {   }
        },
        components:{ QrcodeVue
    //        IconDelete
        },
        computed:{
            ...mapGetters(['urlToApp'])
        },
        
        methods:{
            applyTemplate(template){
                this.$store.dispatch('applyTemplate', template)
                this.$bvModal.hide('linkToAppModal')
                
            },
            deleteTemplate(template){
                this.$store.dispatch('deleteTemplate', template)
            },
            undelete(){
                this.$store.dispatch('undelete')
            },
            emptyTrash(){
                this.$store.dispatch('emptyTrash')
            }
            
        }
    }
    
    </script>
    
    <style scoped>
   .accountTemplate{
     cursor: pointer;
   }
    </style>